import  _ from 'lodash';
import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Constants from 'relevant-shared/reportData/constants';
import SummaryHbCustomizer from 'relevant-shared/reportData/customizers/summaryHbCustomizer';
import FrontendHbCustomizer from './frontendHbCustomizer';
import SystemData from '../../../lib/systemData';

class FrontendSummaryHbCustomizer extends SummaryHbCustomizer {
	getCustomFilters(...args) {
		const hbCustomizer = new FrontendHbCustomizer(this.reportData);
		return hbCustomizer.getCustomFilters(...args);
	}

	splitMetricsToUiGroups(metrics, { sums }) {
		const { ADS_METRICS_EXPANDED } = Constants.summary_hb;
		const adsMetrics = _.pickBy(metrics, (v, k) => ADS_METRICS_EXPANDED.includes(k));
		const normalMetrics = _.pickBy(metrics, (v, k) => !adsMetrics[k]);
		const { hasHbSummaryAdsData } = SystemData.genericData;
		const res = [{ metrics: normalMetrics }];
		if (hasHbSummaryAdsData || sums.some((s) => ADS_METRICS_EXPANDED.includes(s))) {
			res.push({ title: 'Adserver metrics', metrics: adsMetrics });
		}
		return res;
	}

	getReportWarning({ calculator: { settings } }) {
		const placementLevelMetrics = [
			..._.intersection(Constants.summary_hb.PLACEMENT_LEVEL_METRICS, settings?.sums),
			..._.chain(settings.calcSums)
				.pickBy(({ requires }) => _.intersection(Constants.summary_hb.PLACEMENT_LEVEL_METRICS, requires))
				.keys().value(),
		];
		const discrepancy = placementLevelMetrics.length
			&& settings.whereIn?.bidder
			&& !settings.groupBy.includes('bidder');
		return !!discrepancy && (
			<Alert severity="warning">
				<AlertTitle>Warning</AlertTitle>
				The following metric(s) might be unreliable when filtering by bidders:
				{' '}
				<b>{placementLevelMetrics.map((metric) => Constants.summary_hb.SUM_DESCRIPTIONS[metric]).join(', ')}</b>
			</Alert>
		);
	}
}

export default FrontendSummaryHbCustomizer;
